/* ============================================================
   MT — Interacciones de Zapheno
   Todo es progresivo: si algo falla, la página sigue siendo usable.
   Si el visitante pide menos movimiento, no se anima nada.
   ============================================================ */
(function () {
  'use strict';

  var menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Aparición al hacer scroll, con cascada dentro de cada grupo --- */
  function iniciarReveal() {
    var elementos = document.querySelectorAll('.mt-reveal, .mt-palabra');
    if (!elementos.length) return;

    if (menosMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        entrada.target.classList.add('mt-visible');
        observador.unobserve(entrada.target);
      });
      // Se dispara ANTES de que el bloque entre del todo (12% por debajo del
      // borde inferior). Con el margen negativo anterior había que scrollear
      // dentro de la sección para que apareciera, y en el móvil daba la
      // sensación de que las fotos llegaban tarde.
    }, { threshold: 0.02, rootMargin: '0px 0px 12% 0px' });

    elementos.forEach(function (el) { observador.observe(el); });

    // Red de seguridad. Los elementos arrancan en opacidad 0 y solo se ven
    // cuando el observador avisa. Si por lo que sea el navegador no llega a
    // avisar nunca (pestaña en segundo plano al cargar, ahorro de energía,
    // algún navegador raro), la página se quedaría en blanco. Si a los 2
    // segundos no se ha mostrado NADA, se enseña todo de golpe.
    setTimeout(function () {
      if (document.querySelector('.mt-reveal.mt-visible, .mt-palabra.mt-visible')) return;
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    }, 2000);
  }

  /* --- Cascada automática: reparte el retardo entre hermanos --- */
  function prepararCascada() {
    document.querySelectorAll('.mt-reveal--stagger').forEach(function (el) {
      if (el.style.getPropertyValue('--mt-delay')) return; // ya lo fijó la plantilla
      var hermanos = Array.prototype.filter.call(
        el.parentNode ? el.parentNode.children : [],
        function (n) { return n.classList && n.classList.contains('mt-reveal--stagger'); }
      );
      var i = hermanos.indexOf(el);
      if (i > 0) el.style.setProperty('--mt-delay', (i * 80) + 'ms');
    });
  }

  /* --- Titular del hero: revelado palabra a palabra --- */
  function iniciarTitular() {
    var titular = document.querySelector('[data-mt-titular]');
    if (!titular || titular.dataset.mtListo) return;
    titular.dataset.mtListo = '1';

    if (menosMovimiento) { titular.classList.add('mt-visible'); return; }

    var palabras = titular.textContent.trim().split(/\s+/);
    titular.textContent = '';
    palabras.forEach(function (palabra, i) {
      var envoltorio = document.createElement('span');
      envoltorio.className = 'mt-palabra mt-reveal';
      envoltorio.style.setProperty('--mt-delay', (i * 65) + 'ms');
      var interior = document.createElement('span');
      interior.textContent = palabra;
      envoltorio.appendChild(interior);
      titular.appendChild(envoltorio);
      if (i < palabras.length - 1) titular.appendChild(document.createTextNode(' '));
    });
  }

  /* --- Ondulación al pulsar los botones --- */
  function iniciarRipple() {
    if (menosMovimiento) return;
    document.addEventListener('pointerdown', function (e) {
      var boton = e.target.closest('[data-mt-ripple], .mt-boton');
      if (!boton) return;
      var caja = boton.getBoundingClientRect();
      var onda = document.createElement('span');
      var tam = Math.max(caja.width, caja.height);
      onda.className = 'mt-ripple';
      onda.style.width = onda.style.height = tam + 'px';
      onda.style.left = (e.clientX - caja.left - tam / 2) + 'px';
      onda.style.top = (e.clientY - caja.top - tam / 2) + 'px';
      boton.appendChild(onda);
      setTimeout(function () { onda.remove(); }, 750);
    });
  }

  /* --- Botón imantado: sigue al cursor unos pocos píxeles --- */
  function iniciarIman() {
    if (menosMovimiento || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-mt-iman]').forEach(function (boton) {
      boton.addEventListener('pointermove', function (e) {
        var c = boton.getBoundingClientRect();
        var dx = (e.clientX - (c.left + c.width / 2)) / c.width;
        var dy = (e.clientY - (c.top + c.height / 2)) / c.height;
        boton.style.transform = 'translate(' + (dx * 8).toFixed(2) + 'px,' + (dy * 6 - 2).toFixed(2) + 'px)';
      });
      boton.addEventListener('pointerleave', function () { boton.style.transform = ''; });
    });
  }

  /* --- Contadores animados --- */
  function iniciarContadores() {
    var contadores = document.querySelectorAll('[data-mt-contador]');
    if (!contadores.length) return;

    function animar(el) {
      var destino = parseFloat(String(el.dataset.mtContador).replace(',', '.'));
      if (isNaN(destino)) { el.textContent = el.dataset.mtContador; return; }
      var decimales = (String(el.dataset.mtContador).split(/[.,]/)[1] || '').length;
      if (menosMovimiento) { el.textContent = destino.toFixed(decimales).replace('.', ','); return; }

      var inicio = null;
      var duracion = 1400;
      function paso(t) {
        if (inicio === null) inicio = t;
        var p = Math.min((t - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - p, 3);
        el.textContent = (destino * suave).toFixed(decimales).replace('.', ',');
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) { contadores.forEach(animar); return; }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (!en.isIntersecting) return;
        animar(en.target);
        obs.unobserve(en.target);
      });
    }, { threshold: 0.5 });
    contadores.forEach(function (el) { obs.observe(el); });
  }

  /* --- Parallax suave en las fotos grandes --- */
  function iniciarParallax() {
    var piezas = document.querySelectorAll('[data-mt-parallax]');
    if (!piezas.length || menosMovimiento) return;

    var pendiente = false;
    function actualizar() {
      pendiente = false;
      var mitad = window.innerHeight / 2;
      piezas.forEach(function (el) {
        var c = el.getBoundingClientRect();
        if (c.bottom < -200 || c.top > window.innerHeight + 200) return;
        var maximo = parseFloat(el.dataset.mtParallax) || 20;
        var centro = c.top + c.height / 2;
        var avance = (centro - mitad) / mitad; // -1 .. 1
        el.style.transform = 'translate3d(0,' + (avance * maximo * -1).toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(actualizar);
    }, { passive: true });
    actualizar();
  }

  /* --- Barra de progreso de lectura --- */
  function iniciarProgreso() {
    if (menosMovimiento) return;
    var barra = document.createElement('div');
    barra.className = 'mt-progreso';
    document.body.appendChild(barra);

    var pendiente = false;
    function actualizar() {
      pendiente = false;
      var alto = document.documentElement.scrollHeight - window.innerHeight;
      var p = alto > 0 ? window.scrollY / alto : 0;
      barra.style.transform = 'scaleX(' + Math.min(Math.max(p, 0), 1).toFixed(4) + ')';
    }
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(actualizar);
    }, { passive: true });
    actualizar();
  }

  /* --- Cabecera compacta al bajar --- */
  function iniciarCabecera() {
    var pendiente = false;
    function actualizar() {
      pendiente = false;
      document.body.classList.toggle('mt-scrolled', window.scrollY > 80);
    }
    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(actualizar);
    }, { passive: true });
    actualizar();
  }

  /* --- Acordeón con despliegue animado --- */
  function iniciarAcordeon() {
    document.querySelectorAll('[data-mt-acordeon]').forEach(function (item) {
      var resumen = item.querySelector('summary');
      var cuerpo = item.querySelector('.mt-acordeon__cuerpo');
      if (!resumen || !cuerpo) return;

      cuerpo.style.height = item.open ? 'auto' : '0px';

      resumen.addEventListener('click', function (e) {
        if (menosMovimiento) return; // <details> nativo se encarga
        e.preventDefault();

        if (item.open) {
          cuerpo.style.height = cuerpo.scrollHeight + 'px';
          requestAnimationFrame(function () {
            cuerpo.style.transition = 'height 0.4s cubic-bezier(0.22,1,0.36,1)';
            cuerpo.style.height = '0px';
          });
          cuerpo.addEventListener('transitionend', function fin() {
            cuerpo.removeEventListener('transitionend', fin);
            cuerpo.style.transition = '';
            item.open = false;
          });
        } else {
          item.open = true;
          cuerpo.style.height = '0px';
          requestAnimationFrame(function () {
            cuerpo.style.transition = 'height 0.4s cubic-bezier(0.22,1,0.36,1)';
            cuerpo.style.height = cuerpo.scrollHeight + 'px';
          });
          cuerpo.addEventListener('transitionend', function fin() {
            cuerpo.removeEventListener('transitionend', fin);
            cuerpo.style.transition = '';
            cuerpo.style.height = 'auto';
          });
        }
      });
    });
  }

  /* --- Comparador antes/después --- */
  function iniciarComparador() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (visor) {
      var capa = visor.querySelector('[data-mt-comparador-capa]');
      var linea = visor.querySelector('[data-mt-comparador-linea]');
      var tirador = visor.querySelector('[data-mt-comparador-tirador]');
      if (!capa || !linea) return;

      var img = capa.querySelector('img');
      function dimensionar() {
        if (img) img.style.width = visor.clientWidth + 'px';
      }
      function colocar(pct) {
        var p = Math.min(Math.max(pct, 0), 100);
        capa.style.width = p + '%';
        linea.style.left = p + '%';
        if (tirador) tirador.setAttribute('aria-valuenow', Math.round(p));
      }
      function desdeEvento(e) {
        var c = visor.getBoundingClientRect();
        colocar(((e.clientX - c.left) / c.width) * 100);
      }

      dimensionar();
      colocar(50);
      window.addEventListener('resize', dimensionar);

      var arrastrando = false;
      visor.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        visor.setPointerCapture(e.pointerId);
        desdeEvento(e);
      });
      visor.addEventListener('pointermove', function (e) { if (arrastrando) desdeEvento(e); });
      visor.addEventListener('pointerup', function () { arrastrando = false; });
      visor.addEventListener('pointercancel', function () { arrastrando = false; });

      if (tirador) {
        tirador.addEventListener('keydown', function (e) {
          var actual = parseFloat(tirador.getAttribute('aria-valuenow')) || 50;
          if (e.key === 'ArrowLeft') { colocar(actual - 4); e.preventDefault(); }
          if (e.key === 'ArrowRight') { colocar(actual + 4); e.preventDefault(); }
        });
      }
    });
  }

  /* --- Galería de la página de producto --- */
  function iniciarGaleria() {
    document.querySelectorAll('[data-mt-galeria-angulos]').forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-angulo-principal]');
      if (!principal) return;
      galeria.querySelectorAll('[data-mt-angulo-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.dataset.mtSrc;
          if (!src) return;
          principal.style.opacity = '0';
          setTimeout(function () {
            principal.src = src;
            principal.style.opacity = '1';
          }, 180);
          galeria.querySelectorAll('[data-mt-angulo-thumb]').forEach(function (t) { t.classList.remove('mt-activo'); });
          thumb.classList.add('mt-activo');
        });
      });
    });
  }

  /* --- Selector de variantes de la página de producto --- */
  function iniciarVariantes() {
    var datos = document.querySelector('[data-mt-variantes]');
    if (!datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (err) { return; }
    if (!variantes || !variantes.length) return;

    var form = document.querySelector('.mt-producto__form');
    if (!form) return;

    var campoId = form.querySelector('[data-mt-variant-id]');
    var precio = document.querySelector('[data-mt-precio-actual]');
    var precioAntes = document.querySelector('[data-mt-precio-anterior]');
    var boton = form.querySelector('[data-mt-boton-comprar]');
    var botonTexto = form.querySelector('[data-mt-boton-texto]');
    var textoOriginal = botonTexto ? botonTexto.textContent.trim() : 'Añadir a la cesta';
    var seleccion = [];

    // Copia el formato que ya pinta Shopify en el servidor (p. ej. "€23,99"),
    // para que al cambiar de variante el precio no cambie de estilo.
    var molde = precio ? precio.textContent.trim() : '';
    var simbolo = molde.replace(/[\d.,\s]/g, '') || '€';
    var simboloDelante = molde.indexOf(simbolo) === 0;
    function formatearPrecio(centimos) {
      var n = (centimos / 100).toFixed(2).replace('.', ',');
      return simboloDelante ? simbolo + n : n + ' ' + simbolo;
    }

    // El índice de la opción vive en el contenedor .mt-producto__pastillas
    form.querySelectorAll('[data-mt-opcion-index]').forEach(function (grupo) {
      var i = parseInt(grupo.dataset.mtOpcionIndex, 10);
      var activa = grupo.querySelector('.mt-pastilla.mt-activo');
      if (activa) seleccion[i] = activa.dataset.mtValor;

      grupo.querySelectorAll('.mt-pastilla').forEach(function (pastilla) {
        pastilla.addEventListener('click', function () {
          seleccion[i] = pastilla.dataset.mtValor;
          grupo.querySelectorAll('.mt-pastilla').forEach(function (p) { p.classList.remove('mt-activo'); });
          pastilla.classList.add('mt-activo');

          var encontrada = variantes.filter(function (v) {
            return seleccion.every(function (valor, j) { return !valor || v.options[j] === valor; });
          })[0];
          if (!encontrada) return;

          if (campoId) campoId.value = encontrada.id;
          if (precio && encontrada.price != null) {
            precio.textContent = formatearPrecio(encontrada.price);
          }
          if (precioAntes) {
            if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
              precioAntes.textContent = formatearPrecio(encontrada.compare_at_price);
              precioAntes.style.display = '';
            } else {
              precioAntes.style.display = 'none';
            }
          }
          if (boton) boton.disabled = !encontrada.available;
          if (botonTexto) botonTexto.textContent = encontrada.available ? textoOriginal : 'Agotado';

          // Cada variante (1, 2 y 3 tarjetas) tiene su foto: al cambiar de
          // pastilla se enseña la del pack elegido, para que se vea cuantas
          // tarjetas llegan. Tambien se marca su miniatura, o la galeria se
          // quedaria con otra resaltada y pareceria un fallo.
          var principal = document.querySelector('[data-mt-angulo-principal]');
          if (principal && encontrada.featured_image && encontrada.featured_image.src) {
            principal.src = encontrada.featured_image.src;
            var nombre = encontrada.featured_image.src.split('?')[0].split('/').pop();
            document.querySelectorAll('[data-mt-angulo-thumb]').forEach(function (t) {
              var suyo = (t.dataset.mtSrc || '').split('?')[0].split('/').pop();
              t.classList.toggle('mt-activo', suyo === nombre);
            });
          }
        });
      });
    });
  }

  /* --- Barra de compra fija del móvil --- */
  function iniciarBarraCompra() {
    var barra = document.querySelector('[data-mt-barra-compra]');
    var referencia = document.querySelector('[data-mt-boton-comprar]');
    if (!barra || !referencia) return;
    if (barra.dataset.mtEnganchada === 'si') return;
    barra.dataset.mtEnganchada = 'si';
    // Reserva sitio al final de la página: si no, la barra tapa los últimos
    // 77 px y el botón de cierre queda debajo.
    document.body.classList.add('mt-con-barra');

    // Se enseña cuando el botón de arriba ya no se ve. Sin IntersectionObserver
    // (navegador antiguo) la barra se queda escondida: es un extra, no puede
    // estorbar a quien no la necesita.
    if (!('IntersectionObserver' in window)) return;

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        barra.classList.toggle('mt-visible', !entrada.isIntersecting);
      });
    }, { threshold: 0 });
    obs.observe(referencia);

    // El precio de la barra sigue al de arriba cuando se cambia de variante.
    var origen = document.querySelector('[data-mt-precio-actual]');
    var destino = barra.querySelector('.mt-barra-compra__precio');
    if (origen && destino && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var tachado = destino.querySelector('s');
        destino.textContent = origen.textContent;
        if (tachado) destino.appendChild(tachado);
      }).observe(origen, { childList: true, characterData: true, subtree: true });
    }
  }

  function arrancar() {
    iniciarTitular();
    prepararCascada();
    iniciarReveal();
    iniciarRipple();
    iniciarIman();
    iniciarContadores();
    iniciarParallax();
    iniciarProgreso();
    iniciarCabecera();
    iniciarAcordeon();
    iniciarComparador();
    iniciarGaleria();
    iniciarVariantes();
    iniciarBarraCompra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de Shopify recarga secciones sueltas: hay que reenganchar todo.
  document.addEventListener('shopify:section:load', arrancar);
})();
